import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
export default {
  name: 'CoreChartFitText',
  props: {
    value: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    classFontFamily: function classFontFamily() {
      return this.$store.state.app.useAltFonts ? 'roboto' : 'poppins';
    }
  },
  watch: {
    value: function value() {
      var _this = this;

      this.$nextTick(function () {
        _this.fitText();
      });
    }
  },
  mounted: function mounted() {
    this.fitText();
  },
  methods: {
    isOverflown: function isOverflown(element) {
      return element.scrollWidth > element.clientWidth;
    },
    fitText: function fitText() {
      var MAX_FONT_SIZE = 36;
      var MIN_FONT_SIZE = 16;
      var fontSize = MAX_FONT_SIZE;
      var overflow = this.isOverflown(this.$el); // Decrease font-size until it fits or min font-size is reached

      while (overflow && fontSize >= MIN_FONT_SIZE) {
        this.$refs.text.style.cssText = "font-size: ".concat(fontSize, "px !important");
        overflow = this.isOverflown(this.$el);
        fontSize--;
      }

      this.$refs.text.style.cssText = "font-size: ".concat(fontSize, "px !important");
    }
  }
};